import { KnmCollapse } from '../../KnmPackage/MainModule/components/KnmCollapse';
import { IGroupSubjectConditionsForm } from '../PassportGroupFormModule/interfaces/IGroupSubjectConditionsForm';
import { Row } from '../../UIPackage/FormModule/components/Row';
import { TextInput } from '../../UIPackage/MainModule/components/TextInput';
import styles from '../PassportGroupFormModule/components/CommonGroupCondition.module.scss';
import { FieldBlock } from '../../UIPackage/FormModule/components/FieldBlock';
import { SelectInput } from '../../UIPackage/MainModule/components/SelectInput';

interface IPassportGroupDetailSubjectConditionsProps {
  condition: IGroupSubjectConditionsForm | undefined;
}

export const PassportGroupDetailSubjectConditions = ({ condition }: IPassportGroupDetailSubjectConditionsProps) => {
  if (!condition || !Object.values(condition).find(item => !!item)) {
    return null;
  }

  return (
    <KnmCollapse title="Сведения о контролируемом лице мероприятий">
      <>
        {!!condition.subjectTypes?.length && (
          <FieldBlock label="Тип контролируемого лица" margin="bottom">
            <SelectInput value={condition.subjectTypes} isMulti disabled />
          </FieldBlock>
        )}
        {!!condition.regTypes?.length && (
          <FieldBlock label="Наличие контролируемого лица в реестрах" margin="bottom">
            <SelectInput value={condition.regTypes} isMulti disabled />
          </FieldBlock>
        )}
        {!!condition.mspCategories?.length && (
          <FieldBlock label="Категория субъекта МСП" margin="bottom">
            <SelectInput value={condition.mspCategories} isMulti disabled />
          </FieldBlock>
        )}
        {!!condition.checkResultStartDate && !!condition.checkResultEndDate && (
          <Row title="Дата регистрации юридического лица в ЕГРЮЛ, ЕГРИП (интервал)" justify="start" align="center">
            <TextInput value={condition.checkResultStartDate} disabled />
            <span className={styles.DateFieldsSpace}>—</span>
            <TextInput value={condition.checkResultEndDate} disabled />
          </Row>
        )}
      </>
    </KnmCollapse>
  );
};
